import React, {useEffect} from "react";
import { motion } from "framer-motion";
import Header from "../Components/Header";
import BreadcrumbMain from "../Components/BreadcrumbMain";
import heroImg from '../Images/services-hero.webp'

const TermsConditions=()=>{
      useEffect(() => {
                document.title =
                  "Terms & Conditions | LDL Settlement Services";
            
                const metaDesc = document.querySelector("meta[name='description']");
                if (metaDesc) {
                  metaDesc.setAttribute(
                    "content",
                    "Read the terms and conditions for using LDL Settlement Services website and property settlement services."
                  );
                }
            
                const canonical = document.querySelector("link[rel='canonical']");
              if (canonical) {
                canonical.setAttribute("href", "https://ldlsettlementservices.com.au/terms-and-conditions");
              }
            
              const ogTitle = document.querySelector("meta[property='og:title']");
              if (ogTitle) {
                ogTitle.setAttribute(
                  "content",
                  "Terms & Conditions | LDL Settlement Services"
                );
              }
            
                const ogDesc = document.querySelector("meta[property='og:description']");
              if (ogDesc) {
                ogDesc.setAttribute(
                  "content",
                  "Read the terms and conditions for using LDL Settlement Services website and property settlement services."
                );
              }
            
              const ogUrl = document.querySelector("meta[property='og:url']");
              if (ogUrl) {
                ogUrl.setAttribute("content", "https://ldlsettlementservices.com.au/terms-and-conditions");
              }
            
                const ogImage = document.querySelector("meta[property='og:image']");
              if (ogImage) {
                ogImage.setAttribute(
                  "content",
                  "https://ldlsettlementservices.com.au/Images/home-img.webp"
                );
              }
            
                const twitterTitle = document.querySelector("meta[name='twitter:title']");
              if (twitterTitle) {
                twitterTitle.setAttribute(
                  "content",
                  "Terms & Conditions | LDL Settlement Services"
                );
              }
            
                const twitterDesc = document.querySelector(
                "meta[name='twitter:description']"
              );
              if (twitterDesc) {
                twitterDesc.setAttribute(
                  "content",
                  "Read the terms and conditions for using LDL Settlement Services website and property settlement services."
                );
              }
            
                const twitterImage = document.querySelector("meta[name='twitter:image']");
              if (twitterImage) {
                twitterImage.setAttribute(
                  "content",
                  "https://ldlsettlementservices.com.au/Images/home-img.webp"
                );
              }
              }, []);

      const fadeUp = {
    hidden: {
      opacity: 0,
      y: 40,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };
    return(
        <>
        {/**HEADER */}
         <Header
        showBreadcrumb={true}
        pageName="Terms & Conditions"
      />

       {/**HERO SECTION */}
       <BreadcrumbMain
      subTitle="TERMS & CONDITIONS"
      title="Clear Terms. Trusted Settlement Support."
      description="Please review our terms and conditions to understand the responsibilities, processes, and service guidelines that apply when working with LDL Settlement Services across residential and commercial property transactions."
      image={heroImg}
      showIcons={false}
    />

    {/**TERMS & CONDITIONS */}
    <motion.section
        className="privacy-section container"
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          amount: 0.05,
        }}
        variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.08,
            },
          },
        }}
      >

        {/* 1 */}

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          1. Definitions
        </motion.h2>

        <motion.ul
          className="privacy-list"
          variants={fadeUp}
        >

          <li className="section-text">
            In this Contract the following listed words shall
            have the following meanings:
          </li>

        </motion.ul>

        <motion.div
          className="privacy-sub-list"
          variants={fadeUp}
        >

          <p className="section-text">
            <strong>“Customer”</strong> : Any legal entity or
            natural person purchasing services from LDL
            Settlement Services for professional or personal
            property settlement purposes.
          </p>

          <p className="section-text">
            <strong>“Services”</strong> : All settlement,
            conveyancing, transfer, and property-related
            services provided by LDL Settlement Services.
          </p>

          <p className="section-text">
            <strong>“Company”</strong> : LDL Settlement
            Services.
          </p>

          <p className="section-text">
            <strong>“We”, “Our”, “Us”</strong> : Shall mean
            LDL Settlement Services.
          </p>

          <p className="section-text">
            <strong>“Website”</strong> : The website
            <a
              href="https://www.ldlsettlementservices.com.au"
              target="_blank"
              rel="noopener noreferrer"
              className="text-main"
            >
              {" "}
              www.ldlsettlementservices.com.au
            </a>
          </p>

          <p className="section-text">
            <strong>“Seller”</strong> : LDL Settlement
            Services providing professional settlement and
            conveyancing solutions.
          </p>

          <p className="section-text">
            <strong>“Terms of Use”</strong> : These Terms &
            Conditions including any future amendments.
          </p>

          <p className="section-text">
            <strong>“Party”</strong> : The Customer and LDL
            Settlement Services collectively referred to as
            the “Parties”.
          </p>

          <p className="section-text">
            <strong>“You”</strong> : Any natural or legal
            person browsing, accessing, or using the Website
            or Services.
          </p>

          <p className="section-text">
            <strong>“Contract”</strong> : Any agreement,
            instruction, quote acceptance, or transaction
            entered into between the Customer and LDL
            Settlement Services.
          </p>

        </motion.div>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          In this Contract, clause headings are included for
          convenience only and shall not affect interpretation.
        </motion.p>

        {/* 2 */}

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          2. Interpretation
        </motion.h2>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          These Terms & Conditions apply to all services
          provided by LDL Settlement Services unless otherwise
          agreed in writing. If any conflict arises between
          additional agreements and these Terms, the additional
          written agreement shall prevail.
        </motion.p>

        {/* 3 */}

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          3. Service Requests & Instructions
        </motion.h2>

        <motion.ul
          className="privacy-list"
          variants={fadeUp}
        >

          <li className="section-text">
            Requests for settlement services may be submitted
            via phone, email, online enquiry forms, or direct
            consultation.
          </li>

          <li className="section-text">
            LDL Settlement Services may request identification,
            legal documentation, signed authorities, and other
            relevant information required to complete the
            settlement process.
          </li>

          <li className="section-text">
            Clients are responsible for ensuring all
            information provided is accurate, complete, and up
            to date.
          </li>

        </motion.ul>

        {/* 4 */}

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          4. Service Availability
        </motion.h2>

        <motion.ul
          className="privacy-list"
          variants={fadeUp}
        >

          <li className="section-text">
            All services are subject to legal requirements,
            authority approvals, document availability, and
            settlement timelines.
          </li>

          <li className="section-text">
            LDL Settlement Services reserves the right to
            refuse or delay services where insufficient
            documentation or compliance issues exist.
          </li>

        </motion.ul>

        {/* 5 */}

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          5. Fees & Payments
        </motion.h2>

        <motion.ul
          className="privacy-list"
          variants={fadeUp}
        >

          <li className="section-text">
            Quotes provided are estimates based on the
            information available at the time.
          </li>

          <li className="section-text">
            Additional fees, government charges, or third-party
            costs may apply depending on the transaction.
          </li>

          <li className="section-text">
            Payment terms will be outlined before settlement
            completion and must be paid within the agreed
            timeframe.
          </li>

        </motion.ul>

        {/* 6 */}

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          6. Liability
        </motion.h2>

        <motion.ul
          className="privacy-list"
          variants={fadeUp}
        >

          <li className="section-text">
            LDL Settlement Services shall not be liable for
            delays caused by financial institutions, government
            authorities, third parties, system outages, or
            circumstances beyond reasonable control.
          </li>

          <li className="section-text">
            We are not responsible for losses resulting from
            inaccurate information or documents supplied by the
            client or third parties.
          </li>

          <li className="section-text">
            Our liability is limited to the extent permitted
            under Australian law.
          </li>

        </motion.ul>

        {/* 7 */}

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          7. Website Usage
        </motion.h2>

        <motion.ul
          className="privacy-list"
          variants={fadeUp}
        >

          <li className="section-text">
            Content on this website is provided for general
            informational purposes only.
          </li>

          <li className="section-text">
            Users may not copy, reproduce, or distribute any
            website content without prior written permission.
          </li>

          <li className="section-text">
            External links provided on this website are for
            convenience only and LDL Settlement Services is not
            responsible for third-party content.
          </li>

        </motion.ul>

        {/* 8 */}

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          8. Privacy
        </motion.h2>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          Your personal information is handled in accordance
          with our Privacy Policy and applicable Australian
          privacy laws.
        </motion.p>

        {/* 9 */}

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          9. Amendments
        </motion.h2>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          LDL Settlement Services reserves the right to update
          or modify these Terms & Conditions at any time
          without prior notice.
        </motion.p>

        {/* 10 */}

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          10. Contact Information
        </motion.h2>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          For any questions regarding these Terms &
          Conditions, please contact us at
          <a
            href="mailto:admin@ldlsettlementservices.com.au"
            className="text-main"
          >
            {" "}
            admin@ldlsettlementservices.com.au
          </a>
        </motion.p>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          © 2026 – LDL Settlement Services
        </motion.p>

      </motion.section>
        </>
    )
}
export default TermsConditions;